export default [
  {
    path: '/goga-rank',
    component: () => import('./views/Index'),
    name: 'goga-rank-cap-time',
    redirect: { name: 'cap-time-list' },
    children: [
      {
        path: 'cap-time',
        name: 'cap-time-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'management',
        },
      },
    ],
},
]
